import {
	Gallery,
	GallerySlide,
	Lentils,
	styled,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { CarlineWithOfertas } from '../../../services/ofertas-service/models/ofertas';
import { OfertaCardMobile } from './oferta-card-mobile';

export const LentilsWrapper = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	margin-top: var(--size-dynamic0100);
	margin-bottom: var(--size-dynamic0100);
`;

interface OfertaGalleryMobileProps {
	carline: CarlineWithOfertas;
	visibleOfertaIndex: number;
}

export const OfertaGalleryMobile = ({
	carline,
	visibleOfertaIndex,
}: OfertaGalleryMobileProps) => {
	return (
		<Gallery
			id="ofertas-gallery-mobile"
			bottomElements={
				<>
					{carline.ofertas.length > 1 && (
						<LentilsWrapper>
							<Lentils />
						</LentilsWrapper>
					)}
				</>
			}
			fadingEdges="normal"
			slidesPerPage={1}
			aria-label="Ofertas Gallery Mobile"
		>
			{[
				...carline.ofertas.map((oferta, i) => (
					<GallerySlide
						key={oferta.id}
						aria-labelledby={`slide${i}-heading`}
						stretch
					>
						<OfertaCardMobile
							className={`oferta-card-mobile-${oferta.id}`}
							carline={carline}
							currentOferta={oferta}
							visibleOfertaMobile={carline.ofertas[visibleOfertaIndex]}
						/>
					</GallerySlide>
				)),
			]}
		</Gallery>
	);
};
